import { render, staticRenderFns } from "./caseImg.vue?vue&type=template&id=5b7bf5fe&scoped=true"
import script from "./caseImg.vue?vue&type=script&lang=js"
export * from "./caseImg.vue?vue&type=script&lang=js"
import style0 from "./caseImg.vue?vue&type=style&index=0&id=5b7bf5fe&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7bf5fe",
  null
  
)

export default component.exports